// AIDEV-NOTE: iOS "Add to Home Screen" detection. Logic reimplemented (not vendored)
// from philfung/add-to-homescreen. iOS has no programmatic install (no
// beforeinstallprompt), so we detect iOS Safari and surface manual
// Share -> "Add to Home Screen" instructions. iOS Chrome/Firefox/in-app browsers
// cannot install at all, so the guide only targets iOS Safari.

function getUserAgent(): string {
    if (typeof navigator === "undefined") return "";
    return navigator.userAgent;
}

export function isInStandaloneMode(): boolean {
    if (typeof window === "undefined") return false;
    const nav = window.navigator as Navigator & { standalone?: boolean };
    return (
        nav.standalone === true ||
        window.matchMedia("(display-mode: standalone)").matches
    );
}

export function isIOSDevice(): boolean {
    const ua = getUserAgent();
    if (/iPhone|iPad|iPod/.test(ua)) return true;
    // iPadOS 13+ masquerades as "Macintosh" but reports touch points.
    if (
        typeof navigator !== "undefined" &&
        /Macintosh/.test(ua) &&
        navigator.maxTouchPoints > 1
    ) {
        return true;
    }
    return false;
}

export function isIOSSafari(): boolean {
    if (!isIOSDevice()) return false;
    const ua = getUserAgent();
    return (
        /Safari/.test(ua) &&
        !/CriOS/.test(ua) && // Chrome on iOS
        !/FxiOS/.test(ua) && // Firefox on iOS
        !/EdgiOS/.test(ua) && // Edge on iOS
        !/FBAN|FBAV/.test(ua) && // Facebook in-app
        !/LinkedInApp/.test(ua) && // LinkedIn in-app
        !/Instagram/.test(ua) // Instagram in-app
    );
}

// AIDEV-NOTE: Chrome on iOS. Since iOS 16.4 it can Add to Home Screen too, but its share
// button lives at the TOP (then "View More" -> scroll), unlike Safari's bottom toolbar — so
// the install guide anchors differently for it.
export function isIOSChrome(): boolean {
    if (!isIOSDevice()) return false;
    return /CriOS/.test(getUserAgent());
}

// AIDEV-NOTE: iOS 26 reworked the Safari toolbar — the share button is now behind a
// "•••" (More) menu, so the add-to-home-screen steps differ from earlier versions.
// iOS 26 Safari reports a frozen OS string ("OS 18_6") for privacy, so we key off the
// Safari engine version (`Version/26`) instead of the OS token, per the borrowed logic.
export function getIOSSafariMajorVersion(): number | null {
    const match = getUserAgent().match(/Version\/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
}

export function isIOSSafari26OrHigher(): boolean {
    if (!isIOSSafari()) return false;
    const version = getIOSSafariMajorVersion();
    return version !== null && version >= 26;
}
